import { useAppSelector } from 'components/_hooks'
import { Modal } from 'components/_modals'
import { KlLink } from 'components/_shared'
import ChatPersonContainer from 'components/_shared/Chat/_shared/ChatGroupContainer/ChatGroupContainer'
import React, { useMemo } from 'react'
import { makeGetUnreadLastMessages } from 'store/chat/chat-message/chat-message-selectors'
import { useOpenChatList } from 'store/chat/chat/chat-hooks'
import styles from './UnreadChatsModal.module.scss'

interface Props {
  closeDialog: CallableFunction
}


const UnreadChatsModal = ({closeDialog}: Props) => {

  const getMessages = useMemo(makeGetUnreadLastMessages, [])  
  const unreadMessages = useAppSelector(getMessages)

  const openChatList = useOpenChatList()  

  const handleViewChatList = () => {
    openChatList()
    closeDialog()
  }

  return (
    <Modal
      onClose={closeDialog}
      allowOk={false}
      buttonColor="blue"
      hideOk
      cancelButtonText="Close"
      className={styles.window}
    >
      <div className={styles.rightLink}>
        <KlLink to="#" onClick={handleViewChatList}>View all chat list</KlLink>
      </div>
      {unreadMessages.map(mId => (
        <ChatPersonContainer messageId={mId} key={mId} onClick={closeDialog} />
      ))}
    </Modal>
  )
}

export default UnreadChatsModal
